import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "../components/Logo";
import { TriangleAlert, Zap, ChevronRight } from "lucide-react";

export default function Landing() {
    const nav = useNavigate();
    return (
        <div className="relative min-h-screen flex flex-col px-6 pt-10 pb-8 text-white overflow-hidden">
            {/* Background flare */}
            <div className="pointer-events-none absolute -top-40 -left-40 w-[500px] h-[500px] bg-smash/20 blur-[120px] rounded-full" />
            <div className="pointer-events-none absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-dash/15 blur-[120px] rounded-full" />

            <motion.div
                initial={{ opacity: 0, y: -12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="flex items-center justify-between relative z-10"
            >
                <Logo size="md" />
                <Link
                    to="/login"
                    data-testid="landing-login-link"
                    className="text-xs uppercase tracking-[0.2em] text-white/70 hover:text-white"
                >
                    Sign In
                </Link>
            </motion.div>

            <div className="flex-1 flex flex-col justify-center relative z-10">
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.15, duration: 0.6 }}
                >
                    <div className="inline-flex items-center gap-2 border border-dash/60 bg-dash/10 px-3 py-1 mb-6">
                        <TriangleAlert className="w-3.5 h-3.5 text-dash" />
                        <span className="text-[10px] uppercase tracking-[0.25em] text-dash font-semibold">18+ Only</span>
                        <Zap className="w-3.5 h-3.5 text-dash fill-dash" />
                    </div>
                    <h1 className="font-display text-6xl sm:text-7xl leading-[0.9] mb-3">
                        <span className="text-white">SWIPE</span>
                        <span className="text-white/40">.</span>
                        <br />
                        <span className="text-smash">CRACK</span>
                        <span className="text-white/40">.</span>
                        <br />
                        <span className="text-dash">DASH</span>
                        <span className="text-white/40">.</span>
                    </h1>
                    <p className="text-white/70 max-w-sm mt-5 text-sm leading-relaxed">
                        No dinner. No promises. No ghosting drama. Match with adults who want the same thing — then move on with your life.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.35, duration: 0.5 }}
                    className="mt-10 space-y-3"
                >
                    <button
                        data-testid="landing-get-started-btn"
                        onClick={() => nav("/age-gate")}
                        className="w-full h-14 bg-smash hover:bg-smash/90 text-white font-display text-xl tracking-wider uppercase flex items-center justify-center gap-2 transition-colors animate-pulse-danger"
                    >
                        <Zap className="w-5 h-5 fill-white" /> Enter the Floor
                        <ChevronRight className="w-5 h-5" />
                    </button>
                    <Link
                        to="/login"
                        data-testid="landing-existing-account-link"
                        className="block w-full h-14 border border-white/15 hover:border-white/40 text-white/80 font-display text-sm tracking-widest uppercase flex items-center justify-center transition-colors"
                    >
                        I already have an account
                    </Link>
                </motion.div>
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
                className="relative z-10 text-[10px] text-white/40 uppercase tracking-[0.2em] mt-8 text-center"
            >
                By continuing you agree to our terms. Meet at your own risk.
            </motion.div>
        </div>
    );
}
